module.exports = __webpack_public_path__ + "img/20190523210159微信截图_20190523210535.38ffe9eb.png";